import en from './en.json'
import pt from './pt.json'

export default {
  legacy: false,
  locale: 'pt',
  fallbackLocale: 'en',
  messages: {
    en,
    pt
  }
}